<template>
  <div class="container-fluid">
    <net-pa-card>
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-info"></i> درخواست تغییر مدت سپرده
          <span class="float-left" @click="$router.go(-1)"> <i data-v-9331d9a2="" title="بازگشت به صفحه قبلی" class="fas fa-arrow-left text-light Pointer" style="float: left; font-size: 18px"></i></span>
        </h6>
      </template>
      <template slot="content">
        <div class="row">
          <div class="col-md-2 col-12"></div>
          <div class="col-md-8 col-12" v-if="ListRequest.length==0 || (ListRequest.length-1>=0 &&ListRequest[ListRequest.length-1].vaziatGrp44!=null)">
            <div class="row">
              <div class="col-12 text-center">
                <h5>
                  {{ $store.state.NameSandogh }}
                </h5>
                <hr />
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center">
                <h6>
                  {{ 'فرم  درخواست تغییر مدت سپرده' }}
                </h6>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-right mt-5">
                <h6>
                  {{ 'مدیرعامل محترم شرکت تعاونی اعتبار' }}
                </h6>
                <br />
                <h6>
                  {{ 'با سلام' }}
                </h6>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-right">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">{{ 'احتراماً خواهشمند است دستور فرمائيد نسبت به تغيير مدت سپرده گذاری' }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Start Radio 1 -->
            <div class="row">
              <div class="col-1">
                <input type="radio" id="html" name="fav_language" class="Pointer mt-2" :value="1" v-model="IsSaveEmtiaz" />
              </div>
              <div class="col-11 text-right">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="text-wrap: wrap">{{ 'اینـجـانب ' }} </span>
                  </div>
                  <input type="text" disabled v-model="NamFam" class="form-control text-right" aria-label="" />
                  <div class="input-group-append">
                    <span class="input-group-text">{{ 'با کد ملی ' }}</span>
                  </div>
                  <input type="text" disabled v-model="CodeMeli" class="form-control text-left" aria-label="" />

                  <div class="input-group-append">
                    <span class="input-group-text">{{ 'از ' }}</span>
                  </div>
                  <input type="number" @keypress="$ValidNumber($event, 3)" v-model="AzMah" class="form-control text-center" aria-label="" />
                  <div class="input-group-append">
                    <span class="input-group-text">{{ 'مـاه' }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-right">
                <div class="input-group mb-3">
                  <div class="input-group-append">
                    <span class="input-group-text">{{ ' به ' }}</span>
                  </div>
                  <input type="number" @keypress="$ValidNumber($event, 3)" v-model="BeMah" class="form-control text-center" aria-label="" />
                  <div class="input-group-append">
                    <span class="input-group-text">{{ 'مـاه ' }}</span>
                  </div>
                  <div class="input-group-append">
                    <span class="input-group-text">{{ 'و با مدت باز پرداخت ' }}</span>
                  </div>
                  <input type="number" @keypress="$ValidNumber($event, 3)" v-model="ModatBazPardakht" class="form-control text-center" aria-label="" />
                  <div class="input-group-prepend">
                    <span class="input-group-text">{{ ' ماه اقدامات لازم را مبذول نمائيد.' }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- End Radio 1 -->
            <!-- Start Radio 2 -->
            <div class="row mt-4">
              <div class="col-1">
                <input type="radio" id="html" name="fav_language" class="Pointer mt-2" :value="2" v-model="IsSaveEmtiaz" />
              </div>
              <div class="col-11 text-right">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="text-wrap: wrap">{{ 'اینـجـانب ' }} </span>
                  </div>
                  <input type="text" disabled v-model="NamFam" class="form-control text-right" aria-label="" />
                  <div class="input-group-append">
                    <span class="input-group-text">{{ 'با کد ملی ' }}</span>
                  </div>
                  <input type="text" disabled v-model="CodeMeli" class="form-control text-left" aria-label="" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-right">
                <div class="input-group mb-3">
                  <div class="input-group-append">
                    <span class="input-group-text">{{ 'خواستار دريافت تسهيلات خويش در تاريخ ' }}</span>
                  </div>
                  <date-picker class="mr-2" input-class="ml-2 text-center" :editable="true" :auto-submit="true" color="gray" v-model="DaTarikh"> </date-picker>
                  <div class="input-group-append">
                    <span class="input-group-text">{{ 'می باشم لطفا اقدامات لازم را مبذول نمائيد..' }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- End Radio 2 -->

            <div class="row mt-2">
              <div class="col-12 mt-1 text-center">
                <button @click="question()" class="btn btn-submit w-100 mt-2">ثبت درخواست</button>
              </div>
            </div>
          </div>
          <div class="col-md-8 co-12">
            <div class="row">
              <div v-if="ListRequest.length!=0 && (ListRequest[ListRequest.length-1].vaziatGrp44==null)" class="alert alert-warning w-100 text-dark font-weight-bold text-right">شما عضو محترم  درخواست تغییر اقساط خود را در تاریخ {{ zamanInsert }} ارسال کرده اید و تا زمان تغییر وضعیت مدیر سامانه، امکان ارسال مجدد نمی باشد <span class="badge badge-warning p-2 font-weight-normal"> درحال بررسی </span></div>
            </div> 
          </div>
          <div class="col-md-2 col-12"></div>
        </div>
      </template>
    </net-pa-card>
    <net-pa-card>
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-info"></i> سوابق درخواست
        </h6>
      </template>
      <template slot="content">
        <div class="container" style="max-height: 420px; overflow-y: scroll ; overflow-x: hidden; ">
          <div class="row p-4">
            <div v-for="(item, index) in ListRequest" :key="index" class="col-12 border mt-4 p-4 bnp-rounded border Netpa-Shadow">
              <div class="row mt-2">
                  <div class="col-12 col-md-2">
                      <span class="text-secondary">تاریخ درخواست </span>
                      <span class="font-weight-bold">
                          {{item.zamanInsert}}
                      </span>
                  </div>
                  <div class="col-12 col-md-2">
                      <span class="text-secondary">از ماه </span>
                      <span class="font-weight-bold">
                          {{item.azMah}}
                      </span>
                  </div>
                  <div class="col-12 col-md-2">
                      <span class="text-secondary">به ماه </span>
                      <span class="font-weight-bold">
                          {{item.beMah}}
                      </span>
                  </div>
                  <div class="col-12 col-md-2">
                      <span class="text-secondary">مدت باز پرداخت </span>
                      <span class="font-weight-bold">
                          {{item.modatBazPardakht==null ? '-' : item.modatBazPardakht }}
                      </span>
                  </div>
                  <div class="col-12 col-md-2">
                      <span class="text-secondary"> در تاریخ </span>
                      <span class="font-weight-bold">
                          {{item.daTarikh==null ? '-' : item.daTarikh }}
                      </span>
                  </div>
                  <div class="col-12 col-md-2">
                      <span class="text-secondary">وضعیت درخواست </span>
                      <span class="font-weight-bold">
                        <span class="badge badge-warning px-2 font-weight-normal" v-if="item.vaziatGrp44==null"> در حال بررسی </span>
                        <span class="badge badge-success px-2 font-weight-normal" v-if="item.vaziatGrp44==7190"> تاییـــد شد </span>
                        <span class="badge badge-danger px-2 font-weight-normal" v-if="item.vaziatGrp44==7191"> رد شــــد </span>
                      </span>
                  </div>
              </div>
            </div> 

          </div>
        </div>
      </template>

    </net-pa-card>
    <div class="row"></div>
  </div>
</template>
<script>
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
export default {
  components: { NetPaCard },
  data() {
    return {
      NamFam: '',
      CodeMeli: '',
      AzMah: null,
      BeMah: null,
      ModatBazPardakht: null,
      DaTarikh: this.$GetJalaliDate(),
      DataAxios: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'Letter/PostTaghirModatSepordeh',
        Token: this.$session.get('TokenNetPa'),
      },
      IsEnsraf: false,
      zamanInsert: '',
      IsSaveEmtiaz: 1,
      ListRequest: [],
    }
  },
  mounted() {
    this.NamFam = this.$session.get('UserInfoNetPa').ozvName + ' ' + this.$session.get('UserInfoNetPa').ozvFamily
    this.CodeMeli = this.$session.get('UserInfoNetPa').codeMeli.trim()
    this.GetData()
  },
  methods: {
    question() {
      if (this.IsSaveEmtiaz == 1) {
        if (this.AzMah==null || this.AzMah.trim()=="") {
          this.$mySweetDefaultTost('هشدار',' مقدار فیلد از ماه نمیتواند خالی باشد','warning',2000)
          return
        }if (this.BeMah==null || this.BeMah.trim()=="") {
          this.$mySweetDefaultTost('هشدار','مقدار فیلد تا ماه نمیتواند خالی باشد','warning',2000)
          return
        }if (this.ModatBazPardakht==null || this.ModatBazPardakht.trim()=="") {
          this.$mySweetDefaultTost('هشدار','مقدار فیلد مدت باز پرداخت نمیتواند خالی باشد ','warning',2000)
          return
        }
      }
      if (this.IsSaveEmtiaz == 2) {
        if (this.DaTarikh.length!=10) {
          this.$mySweetDefaultTost('هشدار','مقدار فیلد تاریخ نمیتواند خالی باشد ','warning',2000)
          return
        }
      }
      this.$SweetQustion('اطمینان از درخواست تغییر', 'آیا اطمینان دارید که از درخواست تغییر اقساط خود ', 'question', 'تایید ', 'انصراف', this.CodeMeli, this.SendData, this.isNotConfirmed)
    },
    SendData() {
      
      this.DataAxios.ArryfildValue.AzMah = this.IsSaveEmtiaz == 1 ? this.AzMah : null
      this.DataAxios.ArryfildValue.BeMah = this.IsSaveEmtiaz == 1 ? this.BeMah : null
      this.DataAxios.ArryfildValue.ModatBazPardakht = this.IsSaveEmtiaz == 1 ? this.ModatBazPardakht : null
      this.DataAxios.ArryfildValue.DaTarikh = this.IsSaveEmtiaz == 2 ? this.DaTarikh : ""

      this.DataAxios.ArryfildValue.NamFam = this.NamFam
      this.DataAxios.ArryfildValue.CodeMeli = this.CodeMeli

      this.$PostData(this.DataAxios)
        .then((result) => {
          if (result) {
            this.$mySweetDefaultTost('عملیات موفق', 'درخواست تغییر اقساط شما با موفقیت ثبت گردید', 'success', 2000)
          }
        })
        .finally(() => {
          this.GetData()
        })
    },
    isNotConfirmed() {},
    GetData() {
      var formdata = new FormData()
      formdata.append('codemeli', this.CodeMeli)
      var DataAxios_GetData = {
        ArryfildValue: formdata,
        Method: 'Post',
        Action: 'Letter/GetTaghirModatSepordeh',
        Token: this.$session.get('TokenNetPa'),
      }
      this.$PostFormData(DataAxios_GetData).then((data) => {
        console.log('🤦🏻‍♂️ ~ file: RequestLetterTaghirModatSepordeh.vue:206 ~ data:', data)
        if (data.length > 0) {
          this.IsEnsraf = true
          this.zamanInsert = data[data.length - 1].zamanInsert
          this.ListRequest = data
        } else this.IsEnsraf = false
      })
    },
  },
}
</script>
<style scoped>
input[type='text'],
input[type='number'],
input[type='password'],
textarea,
select {
  outline: none;
}

input {
  background: transparent;
  border: none;
  border-bottom: 1px solid #a3a3a3;
}
.input-group-text {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #000000;
  text-align: center;
  white-space: nowrap;
  background-color: transparent;
  border: none !important;
  border-radius: 0px !important ;
}

.btn-submit {
  color: blanchedalmond !important;
  background: linear-gradient(301deg, rgba(145, 124, 193, 1) 0%, rgba(72, 20, 193, 1) 100%);
}

.btn-submit:hover {
  color: blueviolet !important;
  background: #f8f9fa;
  border: solid 3px rgba(72, 20, 193, 1);
}
</style>
